module.exports = __webpack_public_path__ + "img/n2@2x.15c35c74.png";